<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="filter_center_focus" :placeholder="lang.polaris.form.type"
            v-model="form.type" :error="errors.type" :options="typeCodeSelect" 
            v-show="typeCodeSelect && form.parent_id" required="1">
        </trax-ui-select>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.code"
            v-model="form.code" :error="errors.code" required="1" maxlength="8" v-if="form.parent_id">
        </trax-ui-input>
        
        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" :required="1">
        </trax-ui-input>
        
        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.description" 
            v-model="form.description" :error="errors.description" :rows="3" v-if="withDescription && form.parent_id">
        </trax-ui-input>

        <trax-ui-checkbox :text="lang.polaris.training.assessment" v-model="form.assessment" 
            v-if="form.parent_id">
        </trax-ui-checkbox>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint', 'typeCodeSelect', 'indexId', 'withDescription'],
    
        data: function() {
            var props = {
                id: { source:'id' },
                parent_id: { source:'parent_id' },
                type: { source:'type' },
                index_id: { source:'index_id', default: this.indexId },
                order: { source:'data.order' },
                code: { source:'data.code' },
                assessment: { source:'data.assessment' },
                name: { source:'data.name' }
            };
            if (this.withDescription) props.description = { source:'data.description' };
            return {
                lang: lang,
                form: {},
                errors: {},
                props: props,
                titles: {
                    new: lang.polaris.form.new_item,
                    update: lang.polaris.form.item_update
                },
                data: {
                    parent_id: null
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data;
            });
        }
    }
</script>
